// extracted by mini-css-extract-plugin
export default {"filterIcon":"TableFilter_filterIcon__Ds7AL","open":"TableFilter_open__xYs3j"};